// Prose with every http(s) URL in it rendered as a link (through safeHref), opening a new tab
// safely. Evidence lines carry their source inline ("… (pivotnews.ai, 2026-10-02) https://…"),
// and as plain text that source could not be clicked.

import { linkSegments, sourceHost } from '../sidebar/overviewSource';

export function LinkedText({ text, clippedAt }: { text: string; clippedAt?: number }) {
  const segments = linkSegments(text, clippedAt);
  return (
    <>
      {segments.map((segment, index) => segment.href
        ? <a key={index} href={segment.href} target="_blank" rel="noopener noreferrer">{sourceHost(segment.href)} ↗</a>
        : <span key={index}>{segment.text}</span>)}
    </>
  );
}

// A source link on its own: the host and an arrow.
export function SourceLink({ href }: { href: string }) {
  return <a href={href} target="_blank" rel="noopener noreferrer">{sourceHost(href)} ↗</a>;
}
